<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/marrons/Asset 0.png" alt="">

    <span id="marrons_start_text">Tembe puzzel</span>
    <img draggable="false" @click="goToMarronsGame()" class="clickable" id="marron_start_btn" src="./../../assets/images/Asset 30.png" alt="">
    <img draggable="false" id="tembe_pic_1" src="./../../assets/images/marrons/Asset 8.png" alt="">
    <img draggable="false" id="tembe_pic_2" src="./../../assets/images/marrons/Asset 7.png" alt="">
  </span>
</template>

<script>
export default {
  name: "MarronsStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: false,
      });
      this.$router.push('/start');
    },
    goToMarronsGame() {
      this.$router.push('/marrons/game');
    },
    goToMarronsIntro() {
      this.$router.push('/marrons/intro');
    },
  },

  computed: {}
};
</script>

<style>
  #marron_start_btn {
    position: absolute;
    margin-top: 47%;
    left: 69%;
    width: 15%;
  }
  #tembe_pic_1 {
    position: absolute;
    margin-top: 15%;
    left: 8%;
    width: 35%;
  }
  #tembe_pic_2 {
    position: absolute;
    margin-top: 17%;
    left: 56.7%;
    width: 37%;
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
    filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #marrons_start_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 42%;
    width: 40%;
    left: 56%;
    color: white;
    font-size: 4.5vw;
    text-align: center;
    z-index: 1;
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
    filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
</style>


